import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import EditOptions from 'legacy/src/utility/AssessmentActions/actions/EditOptions';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import { withRouter } from 'react-router';

const EditModeAction = (props) => {
  const { label, onClick, assignment, masterSubjectId, router } = props;
  const [openEditOptionsModal, setOpenEditOptionsModal] = useState(false);

  const onEditModeClick = () => {
    setOpenEditOptionsModal(true);
    updatePath();
  };

  const updatePath = () => {
    router &&
      router.push({
        pathname: router.location.pathname,
        query: { ...router.location.query, editMode: true },
      });
  };

  const onSubmit = () => {
    setOpenEditOptionsModal(false);
    onClick();
  };

  const { isAssigned, isInProgress, id } = assignment;

  return (
    <Fragment>
      {openEditOptionsModal && (
        <EditOptions
          data-test-id="edit-mode-editoptions"
          isAssigned={isAssigned}
          isInProgress={isInProgress}
          onSubmit={onSubmit}
          masterSubjectId={masterSubjectId}
          assessmentId={id}
          onClose={() => {
            setOpenEditOptionsModal(false);
          }}
        />
      )}
      <AccessibilityWrapper>
        <SingleAction
          role="link"
          onClick={onEditModeClick}
          tabIndex={0}
          dataTestId="edit-action-link"
          iconName="edit"
        >
          {label}
        </SingleAction>
      </AccessibilityWrapper>
    </Fragment>
  );
};

EditModeAction.propTypes = {
  label: PropTypes.any,
  onClick: PropTypes.func,
  assignment: PropTypes.shape({
    isAssigned: PropTypes.bool.isRequired,
    isInProgress: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  masterSubjectId: PropTypes.string.isRequired,
};

EditModeAction.defaultProps = {
  label: '',
  onClick: () => {},
};

export default withRouter(EditModeAction);
